module.exports = __webpack_public_path__ + "img/tuceng1123.b815a4a7.png";